import { render } from "./TextArea1.vue?vue&type=template&id=c6667aba"
import script from "./TextArea1.vue?vue&type=script&lang=js"
export * from "./TextArea1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__